import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ErrorMessageService } from '../../services';

@Component({
  selector: 'app-form-validation-messages',
  templateUrl: './form-validation-messages.component.html',
  styleUrl: './form-validation-messages.component.scss'
})
export class FormValidationMessagesComponent {
  @Input() form: FormGroup;
  @Input() customErrors: {[key: string]: string} = {};

  Object = Object; // Ez szükséges az ngFor-ban a kulcsok iterálásához

  constructor(private msgService: ErrorMessageService) { 

  }

  getMessages(): string[] {
    return this.msgService.getFormErrorMessages(this.form.errors, this.customErrors);
  }

}
